import Vue from 'vue';
import Router from 'vue-router';
import state from '../store/state';

Vue.use(Router);



const router =  new Router({
    routes: [
        {
            path: '/',
            redirect: '/home',
            meta: { requiresAuth: true }, // 需要用户认证
        },
        {
            path: '/home',
            name: 'Name',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/home'], resolve)
        },
        {
            path: '/test',
            name: 'Test',
            component: resolve => require(['@/pages/test'], resolve)
        },
        {
            path: '/freq/:node/:dir',
            name: 'Freq',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/freq'], resolve),
        },
        {
            path: '/doublewin',
            name: 'Doublewin',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/doublewin'], resolve)
        },
        {
            path: '/multiwin',
            name: 'Multiwin',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/multiwin'], resolve)
        },
        {
            path: '/daydata/:node/:dir',
            name: 'Daydata',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/daydata'], resolve)
        },
        {
            path: '/map',
            name: 'MAP',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/map'], resolve)
        },
        // {
        //     path: '/three/seg',
        //     name: 'Three-seg',
        //     meta: { requiresAuth: true }, // 需要用户认证
        //     component: resolve => require(['@/pages/three/seg'], resolve)
        // },
        // {
        //     path: '/three/wushi',
        //     name: 'Three-wushi',
        //     meta: { requiresAuth: true }, // 需要用户认证
        //     component: resolve => require(['@/pages/three/wushi'], resolve)
        // },
        {
            path: '/three/:tag',
            name: 'Three-page',
            meta: { requiresAuth: true }, // 需要用户认证
            component: resolve => require(['@/pages/three/template'], resolve)
        },
        {
            path: '/login',
            name: 'Login',
            component: resolve => require(['@/pages/login'], resolve)
        },
        {
            path: '/wechat_mini',
            name: 'wechat_mini',
            component: resolve => require(['@/pages/wechat_mini'], resolve),
        },


    ]
});

// 路由守卫
// 检查用户是否已登录
function isLoggedIn() {
    // 获取存储在客户端的JWT
    const token = localStorage.getItem('jwt-token');
    console.log(token)

    // 检查token是否存在并且有效
    if (token) {
        // 这里可以添加进一步的JWT有效性检查，例如检查是否过期
        return true;
    } else {
        return false;
    }
}

router.beforeEach((to, from, next) => {
    // 检查URL中是否有token参数
    const urlToken = to.query.token;
    
    if (urlToken) {
        // 发现URL中有token，执行自动登录
        localStorage.setItem('jwt-token', urlToken);
        
        // 如果没有role和username，设置默认值
        // 如果token是JWT，可以从payload中解析出这些信息
        if (!localStorage.getItem('role')) {
            localStorage.setItem('role', 'user');
        }
        if (!localStorage.getItem('username')) {
            localStorage.setItem('username', 'auto-login-user');
        }
        
        // 更新socket认证信息
        if (window.Vue && window.Vue.prototype && window.Vue.prototype.$socket) {
            window.Vue.prototype.$socket.auth.token = `Bearer ${urlToken}`;
        }
        
        // 从URL中移除token参数，避免暴露在浏览器历史中
        const query = { ...to.query };
        delete query.token;
        
        // 重定向到相同路径但不带token参数
        next({ path: to.path, query: query, replace: true });
        return;
    }
    
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoggedIn()) {
            // 用户未登录，重定向到登录页面
            next({ path: '/login', query: { redirect: to.fullPath } });
        } else {
            next();
        }
    } else {
        console.log('No auth required for this route');
        next();
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js